const keys = {
    COURSES: '/courses',
    COURSES_SINGLE: (id: string) => `/courses/${id}`,
    COURSE_STATUS_UPDATE: (id: string, status: 'view' | 'like' | 'mark') => `/courses/toggle/course/${id}/${status}`,
    COURSES_EPISODE_DURATION: '/courses/set-episode-duration',
    COURSES_CATEGORIES: '/courses/categories',
};

export default keys;

